'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _dec, _dec2, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var _components = require('components');

var _shops = require('redux/modules/shops');

var shopActions = _interopRequireWildcard(_shops);

var _address = require('redux/modules/address');

var addressActions = _interopRequireWildcard(_address);

var _setup = require('redux/modules/setup');

var setupActions = _interopRequireWildcard(_setup);

var _filter = require('redux/modules/filter');

var filterActions = _interopRequireWildcard(_filter);

var _reactRedux = require('react-redux');

var _lodash = require('lodash');

var _CategoriesFilter = require('./CategoriesFilter');

var _CategoriesFilter2 = _interopRequireDefault(_CategoriesFilter);

var _AreasFilter = require('./AreasFilter');

var _AreasFilter2 = _interopRequireDefault(_AreasFilter);

var _reduxAsyncConnect = require('redux-async-connect');

var _lib = require('../../helpers/lib');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Category = (_dec = (0, _reduxAsyncConnect.asyncConnect)([{
  promise: function promise(_ref) {
    var _ref$store = _ref.store,
        dispatch = _ref$store.dispatch,
        getState = _ref$store.getState;

    var promises = [];
    var pathname = getState() && getState().routing && getState().routing.locationBeforeTransitions && getState().routing.locationBeforeTransitions.pathname || 'cham-soc-da-massage';
    promises.push(dispatch(setupActions.setCat(pathname.replace('/', ''))));
    promises.push(dispatch(setupActions.loadSeo(pathname.replace('/', ''))));
    return _promise2.default.all(promises);
  }
}]), _dec2 = (0, _reactRedux.connect)(function (state) {
  return {
    addressFilter: state.address.addressFilter,
    categories: state.setup.categories,
    categoriesFilter: state.setup.categoriesFilter,
    districts: state.address.districts,
    loaded: state.filter.loaded,
    loading: state.filter.loading,
    locationUser: state.user.coords,
    pageSize: state.filter.pageSize,
    province: state.address.province,
    query: state.filter.query,
    shops: state.filter.data,
    sort: state.filter.sort,
    subCatFilter: state.setup.subCatFilter,
    total: state.filter.total,
    cat: state.setup.cat
  };
}, (0, _extends3.default)({}, shopActions, filterActions, addressActions, setupActions)), _dec(_class = _dec2(_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(Category, _Component);

  function Category(props) {
    (0, _classCallCheck3.default)(this, Category);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Category.__proto__ || (0, _getPrototypeOf2.default)(Category)).call(this, props));

    _this.state = {
      collapse: (0, _lib.initCollapse)(_this.props.categories),
      addressFilter: _this.props.addressFilter,
      subCatFilter: _this.props.subCatFilter,
      categoriesFilter: _this.props.categoriesFilter,
      pageSize: 12,
      lazy: false,
      firtInit: false,
      cat: _this.props.cat
    };

    _this.onScroll = function (event) {
      event.preventDefault();
      if (!_this.state.lazy) {
        var wrappedElement = document.getElementById('bodyContent');
        if (_this.state.pageSize < _this.props.total && _this.isBottom(wrappedElement)) {
          _this.setState({ lazy: true });
          var filter = (0, _lib.processQuery)(_this.state.query, _this.props.province, _this.props.addressFilter, _this.props.categoriesFilter, _this.props.subCatFilter, _this.props.sort, _this.props.locationUser);
          filter.pageSize = _this.state.pageSize + 9;
          _this.props.getSearchResult(filter);
        }
      }
    };

    _this.collapseHandle = function (code) {
      var collapse = _this.state.collapse;
      collapse[code] = !collapse[code];
      _this.setState({ collapse: collapse });
    };

    _this.handleChangeMainCat = function (event) {
      var code = String(event.target.name);
      var categoriesFilter = (0, _lodash.clone)(_this.state.categoriesFilter);
      var subCatFilter = (0, _lodash.clone)(_this.state.subCatFilter);
      if (categoriesFilter[code] === 'none') {
        categoriesFilter[code] = 'all';
        for (var index = 0; index < _this.props.categories.length; index++) {
          if (_this.props.categories[index].code === code) {
            var childrens = _this.props.categories[index].childrens;
            for (var jndex = 0; jndex < childrens.length; jndex++) {
              subCatFilter[code] = (0, _lodash.union)(subCatFilter[code], [String(childrens[jndex].code)]);
            }
          }
        }
      } else {
        categoriesFilter[code] = 'none';
        subCatFilter[code] = [];
      }
      _this.props.handleMainCat(categoriesFilter, subCatFilter);
    };

    _this.handleChangeSubCat = function (event) {
      var code = String(event.target.name);
      var parentCode = code.slice(0, -1);
      var subCatFilter = (0, _lodash.clone)(_this.state.subCatFilter);
      var subCat = [];
      var categoriesFilter = (0, _lodash.clone)(_this.state.categoriesFilter);
      if (subCatFilter[parentCode].indexOf(code) === -1) {
        subCat = (0, _lodash.union)(subCatFilter[parentCode], [String(code)]);
      } else {
        subCat = (0, _lodash.without)(subCatFilter[parentCode], String(code));
      }
      subCatFilter[parentCode] = subCat;
      var flag = false;
      for (var index = 0; index < _this.props.categories.length; index++) {
        if (_this.props.categories[index].code === parentCode) {
          if (_this.props.categories[index].childrens.length === subCat.length) {
            flag = true;
          }
        }
      }
      if (flag === true) {
        categoriesFilter[parentCode] = 'all';
      } else if (subCat.length > 0) {
        categoriesFilter[parentCode] = 'notAll';
      } else {
        categoriesFilter[parentCode] = 'none';
      }
      _this.props.handleSubCat(subCatFilter, categoriesFilter);
    };

    _this.hanldeCheckedAddress = function (event) {
      _this.props.handleDistrictFilter(_this.props.addressFilter, String(event.target.name));
    };

    _this.handleChangeSortType = function (event) {
      _this.props.changeSortType(event.target.value);
    };

    _this.getResult = _this.getResult.bind(_this);
    _this.initQuery = _this.initQuery.bind(_this);
    _this.initCategory = _this.initCategory.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(Category, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (!this.props.loaded && this.props.loading !== true || !this.props.shops) {
        this.getResult(this.props.location && this.props.location.query && this.props.location.query.sort);
      }
      if (!this.state.firtInit) {
        this.initQuery();
      }
      var location = this.props.location;
      if (location && (location.pathname !== '/kham-pha' || location.query && location.query.category)) {
        this.initCategory(location);
      }
      document.addEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!(0, _lodash.isEqual)(nextProps.addressFilter, this.props.addressFilter)) {
        this.setState({ addressFilter: nextProps.addressFilter });
      }
      if (!(0, _lodash.isEqual)(nextProps.categoriesFilter, this.props.categoriesFilter)) {
        this.setState({ categoriesFilter: nextProps.categoriesFilter });
      }
      if (!(0, _lodash.isEqual)(nextProps.subCatFilter, this.props.subCatFilter)) {
        this.setState({ subCatFilter: nextProps.subCatFilter });
      }
      if (nextProps.pageSize !== this.props.pageSize) {
        this.setState({ pageSize: nextProps.pageSize });
      }
      if (!nextProps.loading) {
        this.setState({ lazy: false });
      }
      if (nextProps.sort !== this.props.sort) {
        this.getResult(nextProps.sort);
      }
      if (nextProps && nextProps.location && this.props.location) {
        if (nextProps.location.search !== this.props.location.search || nextProps.location.pathname !== this.props.location.pathname) {
          this.initCategory(nextProps.location);
        }
      }
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.initCategory();
      document.removeEventListener('scroll', this.onScroll, true);
    }
  }, {
    key: 'getResult',
    value: function getResult(nextPropsSort) {
      var sort = nextPropsSort ? nextPropsSort : this.props.sort;
      var filter = (0, _lib.processQuery)(this.state.query, this.props.province, this.props.addressFilter, this.props.categoriesFilter, this.props.subCatFilter, sort, this.props.locationUser);
      this.props.getSearchResult(filter);
    }
  }, {
    key: 'isBottom',
    value: function isBottom(el) {
      return el.getBoundingClientRect().bottom <= window.innerHeight;
    }
    // Check collapse filter, get category,

  }, {
    key: 'initCategory',
    value: function initCategory(location) {
      var _this2 = this;

      var catLink = [];
      var sort = this.props.sort;
      var collapse = this.state.collapse;
      if (location && location.pathname !== '/kham-pha') {
        catLink = [location.pathname.replace('/', '')];
      } else {
        catLink = location && location.query && location.query.category && location.query.category.split(',') || [];
        sort = location && location.query && location.query.sort || sort;
      }
      var catCode = [];
      catLink.map(function (value) {
        for (var index = 0; index < _this2.props.categories.length; index++) {
          collapse[_this2.props.categories[index].code] = true;
          if (_this2.props.categories[index].link === value || _this2.props.categories[index].code === value) {
            // Tránh trường hợp code củ chạy không đúng
            catCode.push(_this2.props.categories[index].code);
            collapse[_this2.props.categories[index].code] = false;
          }
        }
      });
      this.setState({ collapse: collapse });
      var categoriesFilter = (0, _lodash.clone)(this.state.categoriesFilter);
      var subCatFilter = (0, _lodash.clone)(this.state.subCatFilter);
      for (var key in categoriesFilter) {
        if (categoriesFilter.hasOwnProperty(key)) {
          if (catCode.indexOf(key) !== -1) {
            categoriesFilter[key] = 'all';
          } else {
            categoriesFilter[key] = 'none';
            subCatFilter[key] = [];
          }
        }
      }
      this.props.handleMainCat(categoriesFilter, subCatFilter);
      if (sort !== this.props.sort) {
        this.props.changeSortType(sort);
      }
    }
  }, {
    key: 'initQuery',
    value: function initQuery() {
      this.setState({ firtInit: true });
      var sort = this.props.sort;
      var query = this.props.query;
      var location = this.props.location;
      sort = location && location.query && location.query.sort ? location.query.sort : sort;
      query = location && location.query && location.query.q ? location.query.q : query;
      if (sort !== this.props.sort) {
        this.props.changeSortType(sort);
      }
      if (query !== this.props.query) {
        this.props.changeQuery(query);
      }
    }
  }, {
    key: 'clearCatFilter',
    value: function clearCatFilter(code) {
      var categoriesFilter = this.state.categoriesFilter;
      var subCatFilter = (0, _lodash.clone)(this.state.subCatFilter);
      if (categoriesFilter[code] === 'none') {
        categoriesFilter[code] = 'all';
        for (var index = 0; index < this.props.categories.length; index++) {
          if (this.props.categories[index].code === code) {
            var childrens = this.props.categories[index].childrens;
            for (var jndex = 0; jndex < childrens.length; jndex++) {
              subCatFilter[code] = (0, _lodash.union)(subCatFilter[code], [String(childrens[jndex].code)]);
            }
          }
        }
      } else {
        categoriesFilter[code] = 'none';
        subCatFilter[code] = [];
      }
      this.props.handleMainCat(categoriesFilter, subCatFilter);
    }
  }, {
    key: 'clearAddressFilter',
    value: function clearAddressFilter(code) {
      var addressFilter = this.state.addressFilter;
      this.props.handleDistrictFilter(addressFilter, code);
    }
  }, {
    key: 'clearQuery',
    value: function clearQuery() {
      this.props.changeQuery('');
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./Discover.scss');
      var _props = this.props,
          shops = _props.shops,
          categories = _props.categories,
          districts = _props.districts,
          query = _props.query,
          total = _props.total,
          sort = _props.sort,
          location = _props.location,
          loading = _props.loading;
      var _state = this.state,
          collapse = _state.collapse,
          addressFilter = _state.addressFilter,
          subCatFilter = _state.subCatFilter,
          categoriesFilter = _state.categoriesFilter,
          lazy = _state.lazy,
          pageSize = _state.pageSize;

      var cards = [];
      var labelType = (0, _lib.paserType)(categories, categoriesFilter);
      var labelAddress = (0, _lib.paserAddress)(districts, addressFilter);
      if (shops && shops.length > 0) {
        var length = shops.length;
        for (var index = 0; index < length; index++) {
          cards.push(_react2.default.createElement(
            'div',
            { className: 'col-xs-6 col-md-4', key: String(index) },
            _react2.default.createElement(_components.ShopCard, { shop: shops[index] })
          ));
        }
      }
      return _react2.default.createElement(
        'div',
        { className: styles.discover },
        _react2.default.createElement(_components.HelmetSEO, { path: this.state.cat, location: location }),
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            _reactBootstrap.Row,
            null,
            _react2.default.createElement(
              _reactBootstrap.Col,
              { md: 3 },
              _react2.default.createElement(
                'div',
                { className: styles.leftContainer },
                _react2.default.createElement(_CategoriesFilter2.default, {
                  categoriesFilter: categoriesFilter,
                  subCatFilter: subCatFilter,
                  categories: categories,
                  collapse: collapse,
                  handleChangeSubCat: this.handleChangeSubCat,
                  collapseHandle: this.collapseHandle,
                  handleChangeMainCat: this.handleChangeMainCat
                }),
                _react2.default.createElement(_AreasFilter2.default, {
                  districts: districts,
                  addressFilter: addressFilter,
                  hanldeCheckedAddress: this.hanldeCheckedAddress
                })
              )
            ),
            _react2.default.createElement(
              _reactBootstrap.Col,
              { md: 9 },
              _react2.default.createElement(
                'div',
                { className: styles.rightContainer },
                _react2.default.createElement(
                  'div',
                  { className: styles.headContent },
                  _react2.default.createElement(
                    'div',
                    { className: styles.topHeader },
                    _react2.default.createElement(
                      'div',
                      { className: styles.leftTab },
                      _react2.default.createElement(
                        'h2',
                        { className: styles.tab + ' ' + styles.activeTab },
                        '\u0110\u1ECBa \u0111i\u1EC3m'
                      )
                    ),
                    _react2.default.createElement(
                      'div',
                      { className: styles.rightTab },
                      _react2.default.createElement(
                        'div',
                        { className: styles.numberShop },
                        _react2.default.createElement(
                          'span',
                          { className: styles.number },
                          total || 0
                        ),
                        ' \u0111\u1ECBa \u0111i\u1EC3m'
                      ),
                      _react2.default.createElement(
                        'div',
                        { className: styles.order },
                        _react2.default.createElement(
                          'label',
                          { htmlFor: 'order' },
                          'S\u1EAFp x\u1EBFp'
                        ),
                        _react2.default.createElement(
                          'select',
                          {
                            name: 'order',
                            id: 'order',
                            className: styles.select + ' ' + styles.minimal,
                            value: sort,
                            onChange: function onChange(event) {
                              return _this3.handleChangeSortType(event);
                            }
                          },
                          _react2.default.createElement(
                            'option',
                            { value: 'prominent' },
                            '\u0110\u1ECBa \u0111i\u1EC3m n\u1ED5i b\u1EADt'
                          ),
                          _react2.default.createElement(
                            'option',
                            { value: 'nearby' },
                            'G\u1EA7n t\xF4i nh\u1EA5t'
                          ),
                          _react2.default.createElement(
                            'option',
                            { value: 'suggest' },
                            '\u0110\u1ECBa \u0111i\u1EC3m g\u1EE3i \xFD'
                          ),
                          _react2.default.createElement(
                            'option',
                            { value: 'booking' },
                            '\u0110\u1ECBa \u0111i\u1EC3m \u0111\u1EB7t l\u1ECBch'
                          ),
                          _react2.default.createElement(
                            'option',
                            { value: 'total_like' },
                            'Nhi\u1EC1u like nh\u1EA5t'
                          ),
                          _react2.default.createElement(
                            'option',
                            { value: 'total_view' },
                            'Nhi\u1EC1u view nh\u1EA5t'
                          ),
                          _react2.default.createElement(
                            'option',
                            { value: 'total_review' },
                            'Nhi\u1EC1u b\xECnh lu\u1EADn nh\u1EA5t'
                          )
                        )
                      )
                    )
                  ),
                  _react2.default.createElement(
                    'div',
                    { className: styles.bottomHeader },
                    query && _react2.default.createElement(
                      'div',
                      { className: styles.itemFilter },
                      'T\u1EEB kh\xF3a',
                      ' ',
                      _react2.default.createElement(
                        'span',
                        { className: styles.valueFilter },
                        query
                      ),
                      _react2.default.createElement('i', {
                        className: 'fa fa-times ' + styles.icon,
                        'aria-hidden': 'true',
                        onClick: function onClick() {
                          return _this3.clearQuery();
                        }
                      })
                    ),
                    labelType && labelType.length > 0 && _react2.default.createElement(
                      'div',
                      { className: styles.groupFilter },
                      labelType.map(function (type, index) {
                        return _react2.default.createElement(
                          'div',
                          { className: styles.itemFilter, key: index },
                          index === 0 ? 'Loại hình ' : '',
                          _react2.default.createElement(
                            'span',
                            { className: styles.valueFilter },
                            type.label
                          ),
                          _react2.default.createElement('i', {
                            className: 'fa fa-times ' + styles.icon,
                            'aria-hidden': 'true',
                            onClick: function onClick() {
                              return _this3.clearCatFilter(type.code);
                            }
                          })
                        );
                      })
                    ),
                    labelAddress && labelAddress.length > 0 && _react2.default.createElement(
                      'div',
                      { className: styles.groupFilter },
                      labelAddress.map(function (type, index) {
                        return _react2.default.createElement(
                          'div',
                          { className: styles.itemFilter, key: index },
                          index === 0 ? 'Khu vực ' : '',
                          _react2.default.createElement(
                            'span',
                            { className: styles.valueFilter },
                            type.label
                          ),
                          _react2.default.createElement('i', {
                            className: 'fa fa-times ' + styles.icon,
                            'aria-hidden': 'true',
                            onClick: function onClick() {
                              return _this3.clearAddressFilter(type.code);
                            }
                          })
                        );
                      })
                    )
                  )
                ),
                _react2.default.createElement(
                  _reactBootstrap.Row,
                  { className: styles.bodyContent, id: 'bodyContent' },
                  shops && shops.length > 0 ? cards : null,
                  (!shops || shops.length === 0) && loading ? _react2.default.createElement('div', { className: styles.lazyLoad }) : null,
                  !(shops && shops.length > 0) && !loading ? _react2.default.createElement(
                    'p',
                    { className: styles.noResult },
                    'Kh\xF4ng t\xECm th\u1EA5y k\u1EBFt qu\u1EA3 ph\xF9 h\u1EE3p.'
                  ) : null
                ),
                _react2.default.createElement(
                  _reactBootstrap.Row,
                  null,
                  pageSize <= total && lazy ? _react2.default.createElement('div', { className: styles.lazyLoad }) : _react2.default.createElement(
                    'p',
                    { className: styles.endResult },
                    '----- End Results -----'
                  )
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Category;
}(_react.Component), _class2.propTypes = {
  addressFilter: _react.PropTypes.array,
  categories: _react.PropTypes.array,
  categoriesFilter: _react.PropTypes.object,
  changeQuery: _react.PropTypes.func.isRequired,
  changeSortType: _react.PropTypes.func,
  districts: _react.PropTypes.array,
  getSearchResult: _react.PropTypes.func.isRequired,
  handleDistrictFilter: _react.PropTypes.func.isRequired,
  handleMainCat: _react.PropTypes.func.isRequired,
  handleSubCat: _react.PropTypes.func.isRequired,
  loaded: _react.PropTypes.bool,
  loading: _react.PropTypes.bool,
  location: _react.PropTypes.object,
  locationUser: _react.PropTypes.object,
  pageSize: _react.PropTypes.number,
  province: _react.PropTypes.string,
  query: _react.PropTypes.string,
  shops: _react.PropTypes.array,
  sort: _react.PropTypes.string,
  subCatFilter: _react.PropTypes.object,
  total: _react.PropTypes.number,
  cat: _react.PropTypes.string
}, _temp)) || _class) || _class);
exports.default = Category;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/containers/Discover/Category.js
// module id = 1673
// module chunks = 0